import React from 'react';
import useSearchAndList from 'utils/hooks/useSearchAndList';
import SearchAndListModal, {
    SearchAndListModalProps,
    SearchCurrencyListItem,
} from '../presentational/SearchAndListModal';

interface SearchAndListModalContainerProps {
    popularList?: SearchAndListModalProps['popularList'];
    othersList?: SearchAndListModalProps['othersList'];
    handleClick: SearchAndListModalProps['handleClick'];
    handleCloseModal: SearchAndListModalProps['handleCloseModal'];
    onSearchChange?: (term: string) => SearchAndListModalProps['result'];
}

const SearchAndListModalContainer = ({
    popularList = [],
    othersList = [],
    handleClick,
    handleCloseModal,
    onSearchChange,
}: SearchAndListModalContainerProps) => {
    const { searchTerm, displayedList, handleSearchTerm } = useSearchAndList<
        SearchCurrencyListItem
    >(onSearchChange);

    return (
        <div className="search-and-list-modal">
            <SearchAndListModal
                handleCloseModal={handleCloseModal}
                handleSearchTerm={handleSearchTerm}
                handleClick={handleClick}
                searchTerm={searchTerm}
                result={displayedList}
                popularList={popularList}
                othersList={othersList}
            />
        </div>
    );
};

export default SearchAndListModalContainer;
